import { TenantConfig } from './types';

/**
 * Configuración para kids.neureka.es (sitio para niños)
 * Tema: Rosa/Amarillo, colorido, juguetón
 * Audiencia: Niños menores de 18 años
 */
export const kidsConfig: TenantConfig = {
  slug: 'kids',
  name: 'Neureka Kids',
  domain: 'kids.neureka.es',

  theme: {
    colors: {
      primary: '#FF6B9D',           // Rosa fuerte
      secondary: '#C06C84',         // Rosa oscuro
      accent: '#FFD93D',            // Amarillo dorado
      background: '#FFF5E1',        // Crema claro
      gradients: {
        main: 'linear-gradient(135deg, #FFD93D 0%, #6BCB77 50%, #4D96FF 100%)',
        header: 'linear-gradient(135deg, #FF6B9D 0%, #C06C84 100%)',
        card: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 100%)',
      },
    },

    fonts: {
      primary: {
        family: 'Fredoka',
        weights: [300, 400, 500, 600],
        googleFont: true,
      },
      body: {
        family: 'Poppins',
        weights: [300, 400, 600],
        googleFont: true,
      },
      decorative: {
        family: 'Comic Neue',
        weights: [400, 700],
        googleFont: true,
      },
    },

    spacing: {
      buttonPadding: '1rem 2rem',
      cardBorderRadius: '24px',
      headerHeight: '80px',
      containerPadding: '1.5rem',
    },

    effects: {
      glassmorphism: true,
      blur: '12px',
      animations: 'playful',
      shadows: 'soft',
    },
  },

  features: {
    enabledGames: [
      'sudoku-kids',
      'memoria',
      'simon',
      'laberinto',
      'diferencias',
      'mastermind-kids',
    ],
    showAdultGames: false,
    timeControl: true,             // Control de tiempo de juego
    parentalControl: true,         // Control parental activo
    multiProfile: true,            // Un padre puede tener varios kids
    sessionTypes: ['presencial'],  // Solo sesiones presenciales
    achievements: 'kids',          // Sistema de logros infantil
    showProfessionalFeatures: false,
    showAdminFeatures: false,
  },

  content: {
    logoText: 'NEUREKA KIDS',
    logoIcon: '🧠',
    tagline: '¡Aprende jugando!',
    homeHero: {
      title: '¡Hola {{kidName}}!',
      subtitle: '¿Qué quieres jugar hoy?',
    },
    footer: {
      text: '© 2024 Neureka Kids - Con amor para los más pequeños',
      links: [
        { label: 'Padres', url: '/parents' },
        { label: 'Política de Menores', url: '/politica-menores' },
      ],
    },
  },

  routes: {
    home: '/index',
    games: '/juegos',
    profile: '/perfil',
    login: '/kids-login',
    selector: '/selector',
  },
};
